export { DEMO_BEATS, type DemoBeatId } from './beats'
export { ProductDemoBeatProvider, useProductDemoBeat } from './context'
export { ProductDemoCaption } from './product-demo-caption'
